import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_gifts_ship_fast: FaireThemeEntity = {
  token: "discovery_theme_gifts-ship-fast",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Gifts That Ship Fast",
  description: "Last-minute gifts with quick turnaround",
  bgColor: "#F5F0D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
